module.exports = __webpack_public_path__ + "img/img18.ec4b54bc.svg";